import {
  HeaderFooterFlagType,
  getDefaultHeaderFooterFlagsByKey,
} from './flags';
import { atom } from 'jotai';

export const headerFooterFeatureFlagAtom = atom<HeaderFooterFlagType>(
  getDefaultHeaderFooterFlagsByKey(),
);
